import { render, staticRenderFns } from "./DialDesign.vue?vue&type=template&id=ad443970&scoped=true"
import script from "./DialDesign.vue?vue&type=script&lang=js"
export * from "./DialDesign.vue?vue&type=script&lang=js"
import style0 from "./DialDesign.vue?vue&type=style&index=0&id=ad443970&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad443970",
  null
  
)

export default component.exports